// extracted by mini-css-extract-plugin
export default {"root":"OyiEhn","disabled":"ZLM_A_"};